"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
require("./index.scss");
class AvatarComponent extends react_1.default.Component {
    render() {
        const { firstName, lastName, small } = this.props;
        const classNames = ['avatar-component', small ? 'small' : ''].join(' ').trim();
        const avatar = `${firstName.substr(0, 1)}${lastName.substr(0, 1)}`;
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("span", { className: 'white-text' }, avatar)));
    }
}
exports.default = AvatarComponent;
